import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { SelectedCustomerObject } from '../operator-permission-dialog/operator-permission-dialog.component';
import { ToastService } from 'src/app/core/services/toast.service';
import {
  AdminGeneratedService,
  PartnerAgreementsDTO,
  ChangeCustomerIdRequest,
  DocumentPrefixPagePartnerCustomersReq,
  PartnerCustomersReq,
  CustomersReq,
  PartnerAndCustomersReq,
} from 'src/app/core/services/AdminService/admin-service-generate';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/destroyAdapter/unsubscribe-on-destroy-adapter';
import {
  FilteringEventArgs,
  highlightSearch,
} from '@syncfusion/ej2-angular-dropdowns';
import { debounce } from '@syncfusion/ej2-base';

@Component({
  selector: 'app-change-customer-dialog',
  templateUrl: './change-customer-dialog.component.html',
  styleUrls: ['./change-customer-dialog.component.css'],
})
export class ChangeCustomerDialogComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit
{
  @ViewChild('toast') toast: ElementRef;
  selectedCustomer: string = null;
  selectedCustomerAggrement: number = null;
  selectedLeaveTime: string = null;
  customerListData = [];
  partnerAggrementListData: PartnerAgreementsDTO[];
  selectedCustomerObject: SelectedCustomerObject;
  moveCounter: boolean = false;
  partnerAndCustomerDataReq;
  partnerAgreementDataReq;

  customerId;
  oldCustomerId;
  public customerListfilterPlaceholder: string = 'Ara';
  customerDDLqueryString = null;

  public fields: Object = {
    text: 'Title',
    value: 'Identity',
    itemCreated: (e: any) => {
      if (this.customerDDLqueryString) {
        setTimeout(() => {
          highlightSearch(
            e.item,
            this.customerDDLqueryString,
            true,
            'Contains'
          );
        }, 100);
      }
    },
  };

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private adminGenerateService: AdminGeneratedService,
    private toastService: ToastService
  ) {
    super();
  }

  ngOnInit(): void {}

  changeClick() {
    var changeCustomerIdRequest = new ChangeCustomerIdRequest({
      oldCustomerId: this.oldCustomerId,
      newCustomerId: this.selectedCustomer,
    });
    this.subs.add(
      this.adminGenerateService
        .changeCustomer(changeCustomerIdRequest)
        .subscribe(
          (res) => {
            if (res.isSuccess) {
              this.toastService.showSuccessToast(this.toast.nativeElement, {
                title: 'Nevi Değiştir',
                content: 'İşleminiz Başarıyla Tamamlanmıştır',
              });
            } else {
              this.toastService.showErrorToast(this.toast.nativeElement, {
                title: 'Nevi Değiştir',
                content: res.resultMessage,
              });
            }
          },
          (err) => {
            const message = JSON.parse(err.response);
            let errorMessage = message.resultMessage;
            this.toastService.showErrorToast(this.toast.nativeElement, {
              title: 'Nevi Değiştir',
              content:
                errorMessage != undefined ? errorMessage : message.Message,
            });
          }
        )
    );
    this.dialogRef.close(this.selectedCustomerObject);
  }

  onFiltering(val: FilteringEventArgs) {
    this.customerDDLqueryString = val.text;
    if (val.text === '') this.customerListData = [];

    if (
      val.text.length < 2 ||
      (this.customerListData.length > 0 &&
        this.customerListData[0].Title.toLowerCase().includes(
          val.text.toLowerCase()
        ))
    ) {
      return;
    }

    val.preventDefaultAction = true;
    this.setDebounce(val);
  }

  setDebounce = debounce((e) => {
    this.onFilter(e);
  }, 600);

  onFilter(val) {
    this.getCustomerSearch(val.text);
    val.updateData(this.customerListData);
  }

  getCustomerSearch(query?, customerId?) {
    this.customerListData = [];
    const req = new PartnerAndCustomersReq({
      filter: query,
      partnerId: JSON.parse(
        sessionStorage.getItem('SELECTED_CUSTOMER_IDENTITY')
      ),
    });
    this.subs.add(
      this.adminGenerateService.customersSearchAll(req).subscribe(
        (res) => {
          this.customerListData = res.map((res) => ({
            Identity: res.identityId,
            Title: res.title + ' / ' + res.identityId,
          }));
        },
        (err) => {}
      )
    );
  }

  customerChange(val) {
    if (val.value != null) {
      this.selectedCustomer = val.value;
    }
  }
}
